/**
 * 时间格式化
 * 
 * @param fmt YYYY-mm-dd HH:MM:SS
 * @param date date:str
 * 
 * 
 */
 export function dateFormat(fmt:any,date:Date){
    var d = new Date(date);//就是这么简单

    let ret;
    const opt:any = {
        "Y+": d.getFullYear().toString(),        // 年
        "m+": (d.getMonth() + 1).toString(),     // 月
        "d+": d.getDate().toString(),            // 日
        "H+": d.getHours().toString(),           // 时
        "M+": d.getMinutes().toString(),         // 分
        "S+": d.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };

    return fmt;
}